import React from 'react';

export interface Size {
	width: number | undefined;
	height: number | undefined;
}

export interface WindowSizeContextType {
	size: Size;
}

export const WindowSizeContext = React.createContext<WindowSizeContextType>({
	size: { width: undefined, height: undefined }
});
